import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

function callForInnovationSwiper() {
    const sections = document.querySelectorAll(
        '[data-name="swiper-call-for-innovation"]'
    )

    if (!sections.length) return

    sections.forEach((section) => {
        const slider = section.querySelector('.swiper')
        const images = section.querySelectorAll(
            '[data-name="swiper-call-for-innovation-image"]'
        )
        const slides = section.querySelectorAll('.swiper-slide')

        images[0].classList.add('opacity-100')
        images[0].classList.remove('opacity-0')

        if (slides.length <= 1) {
            section.querySelector('.swiper-pagination').classList.add('hidden')
        }

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 40,
            modules: [Pagination],
            pagination: {
                el: '[data-name="swiper-call-for-innovation-pagination"]',
                clickable: true,
            },

            on: {
                slideChange: function () {
                    console.log(swiper.activeIndex)
                    console.log(images[swiper.activeIndex])

                    images[swiper.previousIndex].classList.remove('opacity-100')
                    images[swiper.previousIndex].classList.add('opacity-0')
                    images[swiper.activeIndex].classList.remove('opacity-0')
                    images[swiper.activeIndex].classList.add('opacity-100')
                },
            },
        })
    })
}

export default callForInnovationSwiper
